import { PageTemplateView } from "@loot-os/design-system/templates/shared/PageTemplateView";
import { useTenant } from "../lib/tenant.js";
import { useBoxPageContent } from "../templates/pages/box/useBoxPageContent.js";
import { storefrontTemplateOf } from "../templates/registry.js";

/**
 * GET /v1/boxes/:id and the embeddable opener, laid out by the storefront template this
 * environment chose. The content hook and the opener adapter (`components/BoxOpener.tsx`) say what
 * the page does.
 */
export function BoxDetailPage() {
  const { config } = useTenant();
  return (
    <PageTemplateView template={storefrontTemplateOf(config).box} content={useBoxPageContent()} />
  );
}
